module.exports = __webpack_public_path__ + "static/img/feature_3.7e71a26.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/drive/feature_3.png
// module id = m1DW
// module chunks = 0